/**
 * What a World page save does when the page no longer holds its record. A save looks the
 * record up in what the page loaded and sends every field from that copy, so there is
 * nothing it can send.
 *
 * - Deleted on this page: the edit reached it as it went (a panel sends what it holds as it
 *   closes) and is dropped without a word, as the delete meant. Sending it would write the
 *   record back, since the POST is an upsert. (#965)
 * - Anything else, such as a record the new filter left out: the save fails, so the panel
 *   says the edit was not saved rather than "Saved". (#974)
 */
export function saveForMissingRecord(id: string, deletedHere: ReadonlySet<string>): void {
  if (deletedHere.has(id)) return;
  throw new Error(`${id} is not loaded on this page; the edit was not saved`);
}
